import { render, staticRenderFns } from "./Accesses.vue?vue&type=template&id=a12b809c&"
import script from "./Accesses.vue?vue&type=script&lang=js&"
export * from "./Accesses.vue?vue&type=script&lang=js&"
import style0 from "./Accesses.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports